import { Spacing } from 'core/CssVariables';
import styled from 'styled-components';

const SPasswordValidationTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${Spacing.SpacingMD}px;
`;

export default SPasswordValidationTags;
